// CasinoContent.jsx

function HtmlRenderer({ htmlContent }) {
  return (
    <div
      className="prose prose-gray dark:prose-invert max-w-none "
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

const CasinoContent = ({ content }) => {
  return (
    <section className="flex flex-col items-center bg-[#f9fafb] dark:bg-[#1e2430] py-10 transition-colors duration-300">
      {/* ---------- Image Section ---------- */}
      <div className="px-8 md:px-0 md:w-[60%] lg:w-[55%] xl:w-[50%] mx-auto mt-10">
        {content?.image && (
          <img
            src={content?.image}
            alt="Casino Promo"
            className="w-full h-[250px] md:h-[300px] object-cover rounded-2xl border border-gray-300 dark:border-gray-600 transition-colors duration-300"
          />
        )}
      </div>

      {/* ---------- Casino Content Section ---------- */}
      <div className="px-[30px] md:px-0">
        <div
          className="relative  bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 
        rounded-2xl p-10  md:w-[60%] lg:w-[55%] xl:w-[50%] 
        mx-auto mt-8 text-gray-800 dark:text-gray-200 leading-relaxed text-justify 
        transition-colors duration-300"
        >
          <HtmlRenderer htmlContent={content?.content} />
        </div>
      </div>
    </section>
  );
};

export default CasinoContent;
